<template>
  <div class="customer-list-wrapper p-2">
    <div class="row">
      <div class="col-md-4">
        <h4 class="mt-10">Customer List</h4>
      </div>
      <div class="col-md-8">
        <button class="nav-link btn btn-outline-default btn-round btn-default refresh-user-link" v-on:click="refreshUsers">
          <i class="fa fa-refresh"></i> Refresh user list
        </button>
        <button class="nav-link btn btn-outline-default btn-round btn-default refresh-storage-link" v-on:click="refreshStorage">
          <i class="fa fa-refresh"></i> Refresh storage
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h6>Search By:</h6>
        <div class="m-2 row">
          <div class="col-md-3 form-check-radio">
            <label class="form-check-label">
              <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="email" value="email"> Email
              <span class="form-check-sign"></span>
            </label>
          </div>
          <div class="col-md-3 form-check-radio">
            <label class="form-check-label">
              <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="customerID" value="customerID"> Customer Id
              <span class="form-check-sign"></span>
            </label>
          </div>
          <div class="col-md-3 form-check-radio">
            <label class="form-check-label">
              <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="firstName" value="firstName"> First Name
              <span class="form-check-sign"></span>
            </label>
          </div>
          <div class="col-md-3 form-check-radio">
            <label class="form-check-label">
              <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="lastName" value="lastName"> Last Name
              <span class="form-check-sign"></span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div v-if="searchBy" class="row">
      <div class="col-md-3">
        <input v-model="searchQuery" type="text" class="form-control mt-2" placeholder="Search in Customer List" />
      </div>
      <div class="col-md-3">
        <button class="btn btn-primary btn-sm" v-on:click="fetchUsers">
          Search
        </button>
        <button class="btn btn-danger btn-sm" v-on:click="refreshUsers">
          Clear
        </button>
      </div>
    </div>
    <div class="customer-list-info">
      <div class="loader" v-if="(customers.length === 0 && noUser === false) || !asyncDone"></div>
      <p class="card-text text-center text-danger mb-3 font-weight-bold" v-if="noUser && asyncDone">There are no
        user in the database to show here. Please create some users in order for them to show up here.</p>
    </div>
    <div class="customer-table" v-if="customers.length > 0 && asyncDone">

      <table id="datatable" class="table table-striped table-bordered mt-3" cellspacing="0" width="100%">
        <thead>
        <tr>
          <th>Customer ID#</th>
          <th>Name</th>
          <th>Email</th>
          <th>Created</th>
          <th class="d-none">Domains</th>
          <!--					<th>Storage</th>-->
          <!--					<th>Visitors</th>-->
          <th class="disabled-sorting text-right">Actions</th>
        </tr>
        </thead>
        <tfoot>
        <tr>
          <th>Customer ID#</th>
          <th>Name</th>
          <th>Email</th>
          <th>Created</th>
          <th class="d-none">Domains</th>
          <!--					<th>Storage</th>-->
          <!--					<th>Visitors</th>-->
          <th class="disabled-sorting text-right">Actions</th>
        </tr>
        </tfoot>
        <tbody>
        <tr v-for="customer in customers" :key="customer.docID">
          <td>{{ customer.customerID }}</td>
          <td>{{ customer.firstName }} {{ customer.lastName }}</td>
          <td>{{ customer.email }}</td>
          <td class="sort-date">{{ formattedDate(customer.createdAt) }}</td>
          <td class="d-none">{{ customer.domains }}</td>
          <!--					<td class="sort-space">-->
          <!--						<div class="progress" style="height: 20px;" v-for="(space, index) in customer.diskSpace" :key="space + '_' + index" v-if="space">-->
          <!--							<div :class="{'progress-bar': true, 'bg-danger': space > 80}" :style="{'width': space+'%'}" role="progressbar" aria-valuemin="0" aria-valuemax="100">-->
          <!--								{{space}}%-->
          <!--							</div>-->
          <!--						</div>-->
          <!--					</td>-->
          <!--					<td>-->
          <!--						<div v-for="(visitors, index) in customer.allVisitors" v-if="visitors" :key="visitors + '_' + index" class="progress" style="height: 20px;">-->
          <!--							<div :class="{'progress-bar': true, 'bg-danger': visitors > 80}" :style="{'width': visitors+'%'}" role="progressbar" aria-valuemin="0" aria-valuemax="100">-->
          <!--								{{ visitors }}%-->
          <!--							</div>-->
          <!--						</div>-->
          <!--					</td>-->
          <td class="text-right">
            <button type="button" class="btn text-light btn-link bg-primary btn-sm  mr-2 pull-left" @click="goToNuxt(customer.docID)">
              <i class="fa fa-user"></i>
            </button>
            <router-link tag="a" class="btn text-light btn-link bg-default btn-sm edit mr-2 pull-left" :to="{ name: 'editUser', params: { docID: customer.docID } }">
              <i class="fa fa-edit"></i>
            </router-link>
            <button type="button" class="btn text-light btn-link bg-danger btn-sm mr-2 remove pull-left" @click="deleteUser(customer)" :data="customer.docID">
              <i class="fa fa-times"></i>
            </button>
            <button type="button" class="btn text-light btn-link bg-success btn-sm remove pull-left" title="Storage & Visitors" @click="openDetails(customer.docID)">
              Details
            </button>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="row mt-2">
        <div class="col-md-12 text-center">
          <span class="pull-left mt-2"><b>Page Number: </b> {{ pageNumber + 1 }}</span>
          <button class="btn btn-link btn-sm btn-round" :disabled="pageNumber === 0" v-on:click="prevPage">
            Prev
          </button>
          <button class="btn btn-link btn-sm btn-round" :disabled="customers.length < pageSize" v-on:click="nextPage">
            Next
          </button>
        </div>
      </div>
    </div>
    <details-modal ref="details" />
  </div>
</template>


<script>
import {db, functions} from "@/firebase/init";
import _ from 'lodash';
import refreshToken from "../../../../mixins/refreshTokenMixin";
import loginAsMixin from "../../../../mixins/loginAsMixin";
import adminLogs from "../../../../mixins/adminLogs";
import dateMixin from "../../../../mixins/dateMixin";
import DetailsModal from "./detailsModal";
import copyButtonMixin from '../../../../mixins/copyButtonMixin';
import swal from "sweetalert2";

export default {
  name: "CreatedUserList",
  components: {DetailsModal},
  mixins: [loginAsMixin, refreshToken, adminLogs, dateMixin, copyButtonMixin],
  data() {
    return {
      customers: [],
      accounts: [],
      noUser: false,
      countRequests: 0,
      pageNumber: 0,
      pageSize: 10,
      searchQuery: null,
      searchBy: 'email',
      searchByNames: ['firstName', 'lastName']
    };
  },
  watch: {
    searchBy () {
      this.fetchUsers();
    }
  },
  computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    user() {
      return this.$store.getters.user;
    },
    userToken() {
      return this.$store.getters.getUserToken;
    },
    plans() {
      return this.$store.getters["plan/list"];
    },
    last () {
      return (this.customers.length > 0) ? this.customers[this.customers.length-1] : null;
    },
    first () {
      return (this.customers.length > 0) ? this.customers[0] : null;
    }
  },
  methods: {
    nameAdjustments (){
      const result = []
      result.push(this.searchQuery.toLowerCase())
      result.push(this.searchQuery.charAt(0).toUpperCase() + this.searchQuery.slice(1).toLowerCase())
      return result
    },
    openDetails (docId) {
      this.$refs.details.load(docId)
    },
    nextPage(){
      console.log('asd')
      if (this.last) {
        this.pageNumber ++;
        this.noUser = false;
        this.$store.dispatch("async/stateUpdate", {state: false});
        let ref = db.collection("users")
        if (this.searchQuery) {
          ref = ref.where("userType", "==", "normal")
          if(this.searchByNames.includes(this.searchBy)){
            ref = ref.where('this.searchBy' ,'in', this.nameAdjustments())
          }
          else{
            ref = ref.where(this.searchBy, "==", this.searchQuery)
          }
          ref.orderBy("createdAt", "desc")
              .startAfter(this.last.createdAt)
              .limit(this.pageSize)
              .get()
              .then(snapshot => {
                if (snapshot.empty === true) {
                  this.noUser = true;
                }

                this.customers = [];
                snapshot.forEach(doc => {
                  this.customers.push({
                    docID: doc.id,
                    ...doc.data()
                  });
                });
                this.$store.dispatch("async/stateUpdate", {state: true});
              })
              .catch(err => {
                console.log(err);
                // Show error message to the customer for 5 sec
                this.$store.dispatch("alert/update", {
                  type: "danger",
                  message: err.name,
                  show: true
                });

                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", {show: false});
                }, 5000);
              });

        } else {
          ref
              .where("userType", "==", "normal")
              .orderBy("createdAt", "desc")
              .startAfter(this.last.createdAt)
              .limit(this.pageSize)
              .get()
              .then(snapshot => {
                if (snapshot.empty === true) {
                  this.noUser = true;
                }

                this.customers = [];
                snapshot.forEach(doc => {
                  this.customers.push({
                    docID: doc.id,
                    ...doc.data()
                  });
                });
                this.$store.dispatch("async/stateUpdate", {state: true});

              })
              .catch(err => {
                console.log(err);
                // Show error message to the customer for 5 sec
                this.$store.dispatch("alert/update", {
                  type: "danger",
                  message: err.name,
                  show: true
                });

                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", {show: false});
                }, 5000);
              });

        }
      }
    },
    prevPage(){
      if (this.first) {
        this.pageNumber --;
        this.noUser = false;
        this.$store.dispatch("async/stateUpdate", {state: false});
        let ref = db.collection("users");
        if (this.searchQuery) {
          ref =	ref.where("userType", "==", "normal")
          if(this.searchByNames.includes(this.searchBy)){
            ref = ref.where('this.searchBy' ,'in', this.nameAdjustments())
          }
          else {
            ref = ref.where(this.searchBy, "==", this.searchQuery)
          }
          ref.orderBy("createdAt", "desc")
              .endBefore(this.first.createdAt)
              .limitToLast(this.pageSize)
              .get()
              .then(snapshot => {
                if (snapshot.empty === true) {
                  this.noUser = true;
                }

                this.customers = [];
                snapshot.forEach(doc => {
                  this.customers.push({
                    docID: doc.id,
                    ...doc.data()
                  });
                });
                this.$store.dispatch("async/stateUpdate", {state: true});

              })
              .catch(err => {
                console.log(err);
                // Show error message to the customer for 5 sec
                this.$store.dispatch("alert/update", {
                  type: "danger",
                  message: err.name,
                  show: true
                });

                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", {show: false});
                }, 5000);
              });

        } else {
          ref
              .where("userType", "==", "normal")
              .orderBy("createdAt", "desc")
              .endBefore(this.first.createdAt)
              .limitToLast(this.pageSize)
              .get()
              .then(snapshot => {
                if (snapshot.empty === true) {
                  this.noUser = true;
                }

                this.customers = [];
                snapshot.forEach(doc => {
                  this.customers.push({
                    docID: doc.id,
                    ...doc.data()
                  });
                });
                this.$store.dispatch("async/stateUpdate", {state: true});

              })
              .catch(err => {
                console.log(err);
                // Show error message to the customer for 5 sec
                this.$store.dispatch("alert/update", {
                  type: "danger",
                  message: err.name,
                  show: true
                });

                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", {show: false});
                }, 5000);
              });

        }
      }
    },
    refreshUsers() {
      this.customers = [];
      this.accounts = [];
      this.noUser = false;
      this.searchQuery = '';
      this.fetchUsers();
    },
    refreshStorage() {
      this.$http.post("disk/update-all-spaces", {
        grant_type: "token",
        token: this.userToken
      })
          .then(() => {
            this.$store.dispatch("alert/update", {
              type: "info",
              message: "Storage will be updated after 5-10 minutes. After that you can update the list of users.",
              show: true
            });
            this.addLog({
              message: "Storage will be updated after 5-10 minutes. After that you can update the list of users.",
              level: "info"
            })
          })
          .catch((e) => {
            console.log(e);
            this.addLog({
              message: e,
              level: "danger"
            })
          });
    },
    fetchUsers(alertDetails) {
      this.noUser = false;
      this.pageNumber = 0;
      this.$store.dispatch("async/stateUpdate", {state: false});
      // When the page loads, connect with firestore and load all uder details here

      let ref = db.collection("users")
      if (this.searchQuery) {
        ref = ref.where("userType", "==", "normal")
        if (this.searchByNames.includes(this.searchBy)) {
          ref = ref.where(this.searchBy, 'in', this.nameAdjustments())
        } else {
          ref = ref.where(this.searchBy, "==", this.searchBy === 'email' ? this.searchQuery.toLowerCase() : this.searchQuery)
        }
        ref.orderBy("createdAt", "desc")
            .limit(this.pageSize)
            .get()
            .then(snapshot => {
              if (snapshot.empty === true) {
                this.noUser = true;
              }

              this.customers = [];
              snapshot.forEach(doc => {
                this.customers.push({
                  docID: doc.id,
                  ...doc.data()
                });
              });
              if (this.customers.length > 0) {
                this.noUser = false;
              }
              this.$store.dispatch("async/stateUpdate", {state: true});
              // If alertDetails variable passed then show alert with the passed details
              if (alertDetails) {
                // Show success message to the user for 5 sec
                this.$store.dispatch("alert/update", {
                  ...alertDetails
                });
                this.addLog({
                  message: alertDetails,
                  level: "info"
                })
                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", {show: false});
                }, 5000);
              }
            })
            .catch(err => {
              console.log(err);
              // Show error message to the customer for 5 sec
              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err.name,
                show: true
              });
              this.addLog({
                message: err.name,
                level: "danger"
              })
              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", {show: false});
              }, 5000);
            });

      } else {
        ref
            .where("userType", "==", "normal")
            .orderBy("createdAt", "desc")
            .limit(this.pageSize)
            .get()
            .then(snapshot => {
              if (snapshot.empty === true) {
                this.noUser = true;
              }

              this.customers = [];
              snapshot.forEach(doc => {
                this.customers.push({
                  docID: doc.id,
                  ...doc.data()
                });
              });
              if (this.customers.length > 0) {
                this.noUser = false;
              }
              this.$store.dispatch("async/stateUpdate", {state: true});

              // If alertDetails variable passed then show alert with the passed details
              if (alertDetails) {
                // Show success message to the user for 5 sec
                this.$store.dispatch("alert/update", {
                  ...alertDetails
                });
                this.addLog({
                  message: alertDetails,
                  level: "info"
                })
                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", {show: false});
                }, 5000);
              }
            })
            .catch(err => {
              console.log(err);
              // Show error message to the customer for 5 sec
              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err.name,
                show: true
              });
              this.addLog({
                message: err.name,
                level: "danger"
              })
              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", {show: false});
              }, 5000);
            });

      }
    },
    getAccounts() {
      if (!this.accounts.length) {
        db
            .collection("hostingAccounts")
            .get()
            .then(snapshot => {
              this.accounts = [];
              snapshot.forEach(doc => {
                this.accounts.push({
                  docID: doc.id,
                  ...doc.data()
                });
              });
              // localStorage.setItem("accounts", JSON.stringify(this.accounts));
              this.updateDiskSpace();
            })
            .catch(err => {
              console.log(err);
            });
      } else {
        this.updateDiskSpace();
      }
    },
    updateDiskSpace() {
      let customers = this.customers;
      customers = this.customers.map((item) => {
        let diskSpace = [];
        let allVisitors = [];

        item.domains = "";
        let accounts = this.accounts.filter((account) => account.docID === item.docID);
        item.domains = this.getAllAccountDomains(accounts[0].accounts);

        accounts[0].accounts.map((account) => {

          let plan = this.plans.filter((item) => item.name == account.planName);
          let fullDiskSpace = account.fullDiskSpace;
          if (fullDiskSpace !== undefined) {
            try {
              if (Object.keys(fullDiskSpace).length == 3) {
                if (plan.length) {
                  let size = 1;
                  if (fullDiskSpace[2].value == 'G') {
                    size *= 1024;
                  }
                  let maxStorageSize = parseFloat(plan[0].maxStorageSize);
                  if (account.maxStorageSize !== undefined) {
                    maxStorageSize = account.maxStorageSize;
                  }
                  let maxStorageSizeMb = maxStorageSize * 1024;
                  let diskSpaceMb = parseFloat(fullDiskSpace[2].size) * size;


                  let storage = Math.ceil((diskSpaceMb / maxStorageSizeMb) * 100);
                  diskSpace.push(storage);
                }
              }
            } catch (e) {
              console.error(e);
            }
          }

          let visitors = (plan.length && account.allVisitors) ? Math.ceil((account.allVisitors / account.maxVisitors) * 100) : 0;
          if (isNaN(visitors)) {
            visitors = 0;
          }
          allVisitors.push(visitors);
        });

        item.diskSpace = _.sortBy(diskSpace).reverse();
        item.allVisitors = _.sortBy(allVisitors).reverse();
        return item;
      });
      this.customers = customers;
      this.$store.dispatch("async/stateUpdate", {state: true});
      /* eslint-disable */
      // setTimeout(() => {
      // 	$.extend($.fn.dataTableExt.oSort, {
      // 		"num-html-pre": function ( a ) {
      // 			var x = String(a).replace( /<[\s\S]*?>/g, "" );
      // 			x = parseFloat( x );
      // 			if(isNaN(x)){
      // 				return 0;
      // 			}
      // 			return x;
      // 		},
      //
      // 		"num-html-asc": function ( a, b ) {
      // 			return ((a < b) ? -1 : ((a > b) ? 1 : 0));
      // 		},
      //
      // 		"num-html-desc": function ( a, b ) {
      // 			return ((a < b) ? 1 : ((a > b) ? -1 : 0));
      // 		}
      // 	} );
      // 	$.fn.dataTable.moment( 'MMM Do, YYYY, h:mm:ss A' );
      // 	let table = $("#datatable").DataTable({
      // 		destroy: true,
      // 		pageLength: 30,
      // 		pagingType: "full_numbers",
      // 		lengthMenu: [[30, 60, 90, -1], [30, 60, 90, "All"]],
      // 		responsive: true,
      // 		columnDefs: [
      // 			{type: "datetime-moment", targets: "sort-date"},
      // 			{type: "num-html", targets:  5 },
      // 			{type: "num-html", targets:  6 }
      // 		],
      // 		order: [[5, "desc"]],
      // 		language: {
      // 			search: "_INPUT_",
      // 			searchPlaceholder: "Search records"
      // 		}
      // 	});
      // 	table.column(4).visible(false);
      // }, 100);
      /* eslint-enable */
    },
    getAllAccountDomains(accounts) {
      let domains = [];
      accounts.map((account) => {
        domains.push(account.primary.domain);
        account.addon.map((addon) => {
          domains.push(addon.domain);

        })
      });
      return domains.join(', ');
    },
    initTable() {
      this.getAccounts();
    },
    deleteUser(customer) {
      if (
          confirm(
              "Are you certain that you want to delete this user? This process cannot be undone."
          )
      ) {
        // Set asyncDone to false
        this.$store.dispatch("async/stateUpdate", {state: false});

        // Connect with firebase cloud functions and pass the docID as a data parameter to delete the user from the system
        // const deleteUser = functions.httpsCallable("deleteUser");
        // deleteUser({
        // 	uid: customer.docID
        // })
        this.$http.post('user/delete-user', {
          grant_type: 'token',
          uid: customer.docID
        })
            .then(result => {
              if (result.data.message === "success") {

                this.$store.dispatch("async/stateUpdate", {state: false});
                this.addLog({
                  message: `A user has been deleted from the system, Email: ${customer.email}`,
                  level: "info"
                })
                this.fetchUsers({
                  type: "success",
                  message:
                      "The user has successfully been deleted from the system.",
                  show: true
                });

                this.$store.dispatch("async/stateUpdate", {state: true});

                this.$http.post('/algolia/remove-user-all-records', {
                  grant_type: 'token',
                  uid: customer.docID,
                })
              }
            })
            .catch(err => {
              // Show error message to the user for 5 sec
              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err,
                show: true
              });
              this.addLog({
                message: err,
                level: "danger"
              })
              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", {show: false});
              }, 5000);
            });
      }
    }
  },
  mounted() {
    this.$store.dispatch("async/stateUpdate", {state: false});
  },
  created() {
    setTimeout(() => {
      this.fetchUsers();
    }, 1500);
  },
  updated() {
    // const deleteuser = this.deleteUser
    // /* eslint-disable */
    // $("#datatable").on("click", ".remove", function () {
    // 	const docID = $(this).attr("data");
    // 	deleteuser(docID)
    // });
    // /* eslint-enable */
  }
};
</script>

<style>
.refresh-user-link {
  position: absolute;
  top: 15px;
  right: 15px;
}

.refresh-storage-link {
  position: absolute;
  top: 15px;
  right: 215px;
}

.progress {
  margin-bottom: 10px;
}
</style>
